import { black, green, white, yellow, blue } from "./colors/index";

export const colors = {
  ...green,
  ...white,
  ...yellow,
  ...black,
  ...blue,
};
